<section *ngIf="variablesService.social" class="footer-wrapper">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-12 {{!isSipSubscribed ? 'internal-tc-v2' : 'col-sm-4 col-md-4 col-lg-4'}} links internal-tc">
        <div class="logo">
          <img [src]="util.logoUrlDark || util.logoUrlLight" alt=""/>
        </div>
        <div class="policies">
          <span>
            <a rel="noopener" href="/trustandsafety" target="_blank">{{'Terms'}}</a> | 
            <a rel="noopener" href="/privacypolicy" target="_blank">{{'Stories.donations.privacyPolicy' | translatePipe | async}}</a> | 
          </span>
          <span>{{currentYear}} | {{'Stories.allrights' | translatePipe | async}}</span>
      </div>
      </div>
    </div>
  </div>
</section>